/**
 * Every route the app's navigation offers, in one place.
 *
 * The desktop bar and the phone's bottom nav show different subsets of these,
 * and they used to each carry their own copy of the list. That is how a route
 * goes missing: `MobileNav` listed four, the header listed nine, and Placements,
 * Community, Tasks, Approvals and Calendar were simply unreachable below 768px
 * — no app bar renders there, so the bottom nav is the whole of navigation.
 *
 * Split into primary and overflow because the *desktop* bar has room for five
 * before it needs a "More" menu. The phone derives its own overflow from what it
 * could not fit, so a route added here reaches both surfaces without anyone
 * remembering to add it twice.
 */
export type NavRoute = { name: string; href: string }

export const PRIMARY_NAV: readonly NavRoute[] = [
  { name: "Dashboard", href: "/dashboard" },
  { name: "Jobs", href: "/jobs" },
  { name: "Candidates", href: "/candidates" },
  { name: "Placements", href: "/placements" },
  { name: "Searches", href: "/searches" },
]

export const OVERFLOW_NAV: readonly NavRoute[] = [
  { name: "Community", href: "/community" },
  { name: "Tasks", href: "/ops/tasks" },
  { name: "Approvals", href: "/ops/approvals" },
  { name: "Calendar", href: "/calendar" },
]

/**
 * Everything, in the order a person would look for it.
 *
 * The phone's "More" sheet subtracts the tabs it already shows from this, so it
 * is defined as a remainder rather than as a third hand-maintained list.
 */
export const ALL_NAV: readonly NavRoute[] = [...PRIMARY_NAV, ...OVERFLOW_NAV]
